import React from 'react';
import PartnerWrapper from 'components/PartnerWrapper';

export default function PartnerContainer() {

  return (
    <PartnerWrapper />
  )
}
